// TODO: Break out hasDifferentProps into it's own utility function. Change lineItems to something more generic

const hasDifferentProps = ({ lineItems, props }) => {

	const initialDifferentProps = props.reduce(
		(obj, prop) => ({
			...obj,
			[prop]: []
		}),
		{}
	);
	const objOfProps = lineItems.reduce((differentProps, lineItem) => {

		props.forEach((prop) => {

			if (lineItem[prop]) {

				differentProps[prop].push(lineItem[prop]);

			}

		});
		return differentProps;

	}, initialDifferentProps);

	return Object.keys(objOfProps).some((objKey) => objOfProps[objKey].filter((v, i, a) => a.indexOf(v) === i).length > 1);

};

function flattenComboSkuComponents (productItems) {

	if (!productItems.some((item) => item.LineItems && item.LineItems.length > 0)) {

		return productItems;

	}

	return productItems.reduce((newProducts, product) => {

		const { LineItems, AvailableShippingOptions, ForceRemoveErrorMessages } = product;
		if (
			LineItems &&
			LineItems.length > 0 &&
			(!AvailableShippingOptions || !AvailableShippingOptions.length) &&
			!ForceRemoveErrorMessages.length &&
			(LineItems.some((item) => item.AvailableShippingOptions && item.AvailableShippingOptions.length > 0) ||
				hasDifferentProps({
					lineItems: LineItems,
					props: [ 'PickUpStoreNumber', 'PickupInventoryStoreNumber' ]
				}))
		) {

			return [ ...newProducts, ...LineItems ];

		}

		return [ ...newProducts, product ];

	}, []);

}

export default flattenComboSkuComponents;
